import http from "@/http/aisea/axios";
const resource = "/enterprises/radar-grid/objects";

export default {
  create({ radar_detected_object_id, ...options }) {
    return http.post(
      `${resource}/${radar_detected_object_id}/risk-assessments`,
      options,
    );
  },
};
